import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Breadcrumbs from 'react-router-dynamic-breadcrumbs';
import ReactJWPlayer from 'react-jw-player';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Redirect } from 'react-router-dom';

import { DataHandler, APIHandler } from 'C4';
import { storageKeys } from 'settings';

const crumbRoutes = {
  '/main': 'Home',
  '/main/sell': 'Sell',
  '/main/sell/videos': 'Videos',
};

export default class CarouselVideos extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentSlideIndex: 0,
      videos: [],
      escaped: false,
    };

    this.handleAfterSlide = this.handleAfterSlide.bind(this);
    this.onEsc = this.onEsc.bind(this);
  }

  componentWillMount() {
    document.addEventListener('keydown', this.onEsc);
    window.scrollTo(0, 0);
    DataHandler.matchAppId().then((id) => {
      const appId = id;
      DataHandler.checkKey(storageKeys.videos, APIHandler.getVideos(appId))
        .then((videos) => {
          this.setState({ videos: videos.items });
        });
    });
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onEsc);
  }

  onEsc(e) {
    if (e.key === 'Escape') {
      this.setState({ escaped: true });
    }
  }

  handleAfterSlide(newSlideIndex) {
    this.setState({ currentSlideIndex: newSlideIndex });
  }


  render() {
    const { videos, currentSlideIndex, escaped } = this.state;
    const videoItems = [];
    videos.forEach((video, id) => {
      const {
        thumbnail,
        title,
        url,
      } = video;
      const key = id;

      if (key <= currentSlideIndex && key >= currentSlideIndex) {
        videoItems.push((
          <div key={key} >
            <h3>{title}</h3>
            <ReactJWPlayer
              playerId={`video-player-${key}`}
              playerScript="https://content.jwplatform.com/libraries/gj8NKibk.js"
              file={url}
              image={thumbnail}
              onComplete={this.nextSlide}
              onError={this.nextSlide}
            />
          </div>));
      } else {
        videoItems.push(<div key={key} />);
      }
      return null;
    });

    const { url, params } = this.props.match;
    const { videoId } = params;

    const redirPath = (
      videoId !== undefined
        ? url.substring(0, url.lastIndexOf('/')).lastIndexOf('/')
        : url.lastIndexOf('/')
    );

    return (
      <div className="carousel__Container">
        <div className="carousel__Background--overlay" />
        <Breadcrumbs
          mappedRoutes={crumbRoutes}
          WrapperComponent={props => <ul className="breadcrumb__List carousel">{props.children}</ul>}
          LinkComponent={props => <li className="breadcrumb__item">{props.children}<span className="breadcrumb__separator">&#62;</span></li>}
          ActiveLinkComponent={props => <li className="breadcrumb__item--active">{props.children}</li>}
        />
        {escaped && <Redirect to={url.substring(0, redirPath)} />}
      </div>
    );
  }
}

CarouselVideos.propTypes = {
  match: PropTypes.shape().isRequired,
};
